import Typography from "@mui/material/Typography";
import type { SearchTemplateValue, User } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { setClassNamesByCount } from "./utils";

export const AllNeedsAttention = ({
	needsAttention,
	readOnly = false,
	title,
	tag,
}: {
	needsAttention: SearchTemplateValue;
	activeUser: User;
	readOnly?: boolean;
	title: string;
	tag: string;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(needsAttention.count)}
			title={
				<AttentionBadge
					count={needsAttention.count}
					title={title}
					readOnly={readOnly}
					url={needsAttention.url}
				/>
			}
			description={
				<Typography variant="body1" component="div" color="textPrimary">
					Respond or mark as done
				</Typography>
			}
			to={needsAttention.url}
			readOnly={readOnly}
		/>
	);
};
